'use client';

import { useEffect, useRef, useState } from 'react';

import {
  mountBnplBadge,
  MountBnplBadgeOptions
} from '@/fo/api/payment/yandex-pay';

import { styles } from './UiPaymentBnplBadge.styles';

export interface UiPaymentBnplBadgeProps
  extends Omit<MountBnplBadgeOptions, 'element'> {
  className?: string;
}

export function UiPaymentBnplBadge({
  amount,
  size = 'm',
  variant = 'detailed',
  color = 'transparent',
  theme = 'light',
  align = 'left',
  className
}: UiPaymentBnplBadgeProps) {
  const slots = styles();
  const ref = useRef<HTMLDivElement>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (!amount || amount <= 0) return;

    el.innerHTML = '';
    setIsLoaded(false);

    let cancelled = false;
    void mountBnplBadge({
      element: el,
      amount,
      size,
      variant,
      color,
      theme,
      align
    }).then(() => {
      if (!cancelled) setIsLoaded(true);
    });

    return () => {
      cancelled = true;
      el.innerHTML = '';
    };
  }, [amount, size, variant, color, theme, align]);

  return (
    <div
      ref={ref}
      className={slots.base({ className, isLoaded })}
      aria-label="yandex-pay-split-badge"
    />
  );
}

export default UiPaymentBnplBadge;
